export default "__VITE_ASSET__B82kO13W__"